export default [
  {level: '初中', grades: ['初一', '初二', '初三']},
  {level: '高中', grades: ['高一', '高二', '高三']},
]



// WEBPACK FOOTER //
// ./src/constants/grades.js